// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"12eaebc1","453":"0809ced0","604":"b39180cd"}[chunkId] + ".chunk.js";
};